<template>
  <Container type="card-full">
    <div slot="header"  v-if="type === 1 || type === 2" >
      <div class="groupbtn">
        <div style="padding-right: 10px"  v-if="+project.projectstatus === 10">
        <upload-btn @changed='setfile'  text="上传公告附件"></upload-btn>
        </div>
      <!--<el-button @click="fbgg" :loading="btnLoading" v-if="+project.projectstatus === 10">上传竞价文件</el-button>-->
      <el-button @click="fbgg" :loading="btnLoading" v-if="+project.projectstatus === 10">发布公告</el-button>
      <el-button @click="lodopPrint" :loading="btnLoading">打印</el-button>
      <el-button @click="close">关闭</el-button>
      <span class="status" v-if="+project.projectstatus > 10">已发布公告</span>
      </div>
    </div>
    <div>
      <table class="x-table" style="table-layout:fixed;width:734px;" border="1" cellspacing="0" id="px" cellpadding="0">
    <colgroup>
      <col style="width:83px;" col="1">
      <col style="width:115px;" col="2">
      <col style="width:92px;" col="3">
      <col style="width:94px;" col="4">
      <col style="width:90px;" col="5">
      <col style="width:82px;" col="6">
      <col style="width:84px;" col="7">
      <col style="width:94px;" col="8">
    </colgroup>
    <tbody>
      <tr style="height:60px;" >
        <td style="display:none;" col="0"   row="2"></td>
        <td class="fh tac bw fwb f14-0 pl2 b0" style="color:rgb(255,0,0);font-family:微软雅黑;" col="1"
          colspan="8"   row="2"> {{project.projectname}}（项目编号：{{project.projectcode}}）项目公告</td>
        <td class="fh bw pl2 b0" style="display:none;" col="9"  row="2"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="10"  row="2"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="11"  row="2"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="12"  row="2"></td>
      </tr>
      <tr style="height:38px;" >
        <td class="fh bw pl2 b0" style="display:none;" col="0"  row="3" ></td>
        <td class="fh bw f10-0 pl2 b0" col="1" colspan="4"
           row="3"  >采购人: {{project.pcomfullname}}</td>
        <td class="fh tar bw f10-0 pl2 b0" col="5"  colspan="4"
          row="3"  >项目编号: {{project.projectcode}}</td>
        <td class="fh bw pl2 b0" style="display:none;" col="9"  row="3"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="10" row="3"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="11"  row="3"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="12"  row="3"></td>
      </tr>
      <tr style="height:30px;" >
        <td class="fh bw pl2 b0" style="display:none;" col="0"  row="4"></td>
        <td class="fh tac bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="background-color:rgb(245,245,245);border-bottom-color:rgb(192,192,192);border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);"
          col="1" row="4"  >项目名称</td>
        <td class="fh tal bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);border-bottom-color:rgb(192,192,192);"
          col="2" colspan="7"   row="4"  > {{project.projectname}}</td>
        <!-- <td class="fh tac bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="background-color:rgb(245,245,245);border-bottom-color:rgb(192,192,192);border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);"
          col="5" row="4"  >项目内容</td>
        <td class="fh tac bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);border-bottom-color:rgb(192,192,192);"
          col="6" colspan="3"  row="4"  >{{project.projectdesc}}</td>
        <td class="fh bw pl2 b0" style="display:none;" col="9"  row="4"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="10"  row="4"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="11"  row="4"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="12"  row="4"></td> -->
      </tr>
      <tr style="height:32px;" >
        <td class="fh bw pl2 b0" style="display:none;" col="0"  row="5"></td>
        <td class="fh tac bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="background-color:rgb(245,245,245);border-bottom-color:rgb(192,192,192);border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);"
          col="1" row="5" >采购人联系人</td>
        <td class="fh tal bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);border-bottom-color:rgb(192,192,192);"
          col="2"   row="5">{{project.pusername}}</td>
        <td class="fh tac bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="background-color:rgb(245,245,245);border-bottom-color:rgb(192,192,192);border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);"
          col="3" row="5"  >联系电话</td>
        <td class="fh tal bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);border-bottom-color:rgb(192,192,192);"
          col="4"  row="5"  >{{project.projectptel}}</td>
        <td class="fh tac bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="background-color:rgb(245,245,245);border-bottom-color:rgb(192,192,192);border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);"
          col="5"  row="6"  >交易方式</td>
        <td class="fh tal bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);border-bottom-color:rgb(192,192,192);"
          col="6" row="6"  >竞价</td>
          <td class="fh tac bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="background-color:rgb(245,245,245);border-bottom-color:rgb(192,192,192);border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);"
          col="7" row="6"  >报价是否含税</td>
        <td class="fh tal bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);border-bottom-color:rgb(192,192,192);"
          col="8" row="6"  >{{+project.projecthsflg ===1 ? '是' :'否'}}</td>

        <td class="fh bw pl2 b0" style="display:none;" col="9"  row="5"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="10"  row="5"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="11"  row="5"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="12"  row="5"></td>
      </tr>
      <tr style="height:32px;" v-if ="project.projecttype ==='1'">
        <td class="fh bw pl2 b0" style="display:none;" col="0"  row="6"></td>
         <td class="fh tac bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="background-color:rgb(245,245,245);border-bottom-color:rgb(192,192,192);border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);"
          col="5"  row="5"  >采购采购人</td>
        <td class="fh tal bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);border-bottom-color:rgb(192,192,192);"
          col="6"     row="5"  colspan="3">{{project.comfullname}}</td>
        <td class="fh tac bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="background-color:rgb(245,245,245);border-bottom-color:rgb(192,192,192);border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);"
          col="1" row="6"  >采购人联系人</td>
        <td class="fh tal bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);border-bottom-color:rgb(192,192,192);"
          col="2"  row="6"  colspan="1">{{project.ausername}}</td>
        <td class="fh tac bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="background-color:rgb(245,245,245);border-bottom-color:rgb(192,192,192);border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);"
          col="3"  row="6"  >采购人联系电话</td>
        <td class="fh tal bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);border-bottom-color:rgb(192,192,192);"
          col="4"  row="6"  >{{project.projectatel}}</td>
        <td class="fh bw pl2 b0" style="display:none;" col="9"  row="6"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="10"  row="6"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="11" row="6"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="12"  row="6"></td>
      </tr>
      <tr style="height:32px;" tridx="7" >
        <td class="fh bw pl2 b0" style="display:none;" col="0"  row="7"></td>
        <td class="fh tac bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="background-color:rgb(245,245,245);border-bottom-color:rgb(192,192,192);border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);"
          col="1"  row="7"  >报名开始时间</td>
        <td class="fh tal bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);border-bottom-color:rgb(192,192,192);"
          col="2" row="7"  > {{project.prsbmbegtime | newDate}} </td>
        <td class="fh tac bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="background-color:rgb(245,245,245);border-bottom-color:rgb(192,192,192);border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);"
          col="3" row="7"  >报名截止时间</td>
        <td class="fh tal bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);border-bottom-color:rgb(192,192,192);"
          col="4" row="7"  >{{project.prsbmendtime | newDate}}</td>
        <td class="fh tac bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="background-color:rgb(245,245,245);border-bottom-color:rgb(192,192,192);border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);"
          col="5"  row="7"  >报价开始时间</td>
        <td class="fh tal bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);border-bottom-color:rgb(192,192,192);"
          col="6" row="7" >{{project.prsbjbegtime | newDate}}</td>
        <td class="fh tac bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="background-color:rgb(245,245,245);border-bottom-color:rgb(192,192,192);border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);"
          col="7" row="7" >报价截止时间</td>
        <td class="fh tal bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);border-bottom-color:rgb(192,192,192);"
          col="8" row="7" >{{project.prsbjendtime | newDate}}</td>
        <td class="fh bw pl2 b0" style="display:none;" col="9"  row="7"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="10"  row="7"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="11" row="7"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="12" row="7"></td>
      </tr>
      <tr style="height:30px;" tridx="8">
        <td class="fh bw pl2 b0" style="display:none;" col="0" row="8"></td>
        <td class="fh tac bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="background-color:rgb(245,245,245);border-bottom-color:rgb(192,192,192);border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);"
          col="1" row="8"  >采购预算</td>
        <td class="fh tar bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);border-bottom-color:rgb(192,192,192);"
          col="2" cv="12000"  row="8" >{{project.projectlimitamt | qfwVal}}</td>
        <!-- <td class="fh tac bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="background-color:rgb(245,245,245);border-bottom-color:rgb(192,192,192);border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);"
          col="3"  row="8"  >项目低价</td>
        <td class="fh tac bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);border-bottom-color:rgb(192,192,192);"
          col="4" row="8" >{{project.projectlimitamt}}</td> -->
        <td class="fh tac bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="background-color:rgb(245,245,245);border-bottom-color:rgb(192,192,192);border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);"
          col="7" row="8"  >采购品目</td>
        <td class="fh tal bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);border-bottom-color:rgb(192,192,192);"
          col="8"  colspan="5" row="8"  >{{project.pmname}}</td>
        <td class="fh bw pl2 b0" style="display:none;" col="9"  row="8"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="10"  row="8"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="11" row="8"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="12"  row="8"></td>
      </tr>
      <tr style="height:31px;" >
        <td class="fh bw pl2 b0" style="display:none;" col="0"  row="10"></td>
        <td class="fh tac bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="background-color:rgb(245,245,245);border-bottom-color:rgb(192,192,192);border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);"
          col="1"  row="10" >报价次数</td>
        <td class="fh tal bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss presentable" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);border-bottom-color:rgb(192,192,192);"
          col="2"  colspan="7"  row="10" >{{project.prsbjtimes}}次</td>
        <td class="fh bw pl2 b0" style="display:none;" col="9" ></td>
        <td class="fh bw pl2 b0" style="display:none;" col="10" ></td>
        <td class="fh bw pl2 b0" style="display:none;" col="11" ></td>
        <td class="fh bw pl2 b0" style="display:none;" col="12" ></td>
      </tr>
      <tr style="height:30px;" >
        <td class="fh bw pl2 b0" style="display:none;" col="0" ></td>
        <td class="fh tac bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="background-color:rgb(245,245,245);border-bottom-color:rgb(192,192,192);border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);"
          col="1" c row="11" >报价规则</td>
        <td class="fh tal bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);border-bottom-color:rgb(192,192,192);"
          col="2" colspan="7" row="11" >{{project.prsflgdesc}}</td>
        <td class="fh bw pl2 b0" style="display:none;" col="9" row="11"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="10"  row="11"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="11"  row="11"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="12"  row="11"></td>
      </tr>
      <tr style="height:30px;" >
        <td class="fh bw pl2 b0" style="display:none;" col="0" ></td>
        <td class="fh tac bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="background-color:rgb(245,245,245);border-bottom-color:rgb(192,192,192);border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);"
          col="1" row="12"  >定标规则</td>
        <td class="fh tal bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);border-bottom-color:rgb(192,192,192);"
          col="2"  colspan="7" row="12" >{{project.projectdoneflgdesc}}</td>
        <td class="fh bw pl2 b0" style="display:none;" col="9" ></td>
        <td class="fh bw pl2 b0" style="display:none;" col="10" ></td>
        <td class="fh bw pl2 b0" style="display:none;" col="11" ></td>
        <td class="fh bw pl2 b0" style="display:none;" col="12" ></td>
      </tr>
      <tr style="height:30px;">
        <td class="fh tac bw fwb f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="background-color:rgb(245,245,245);border-bottom-color:rgb(192,192,192);border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);"
          col="1" row="14" >序号</td>
        <td class="fh tac bw fwb f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="background-color:rgb(245,245,245);border-bottom-color:rgb(192,192,192);border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);"
          col="2"   row="14" >品目名称</td>
        <td class="fh tac bw fwb f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="background-color:rgb(245,245,245);border-bottom-color:rgb(192,192,192);border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);"
            col="3"  row="14" >单位</td>
        <td class="fh tac bw fwb f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="background-color:rgb(245,245,245);border-bottom-color:rgb(192,192,192);border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);"
          col="4"  row="14" >数量</td>
        <td class="fh tac bw fwb f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="background-color:rgb(245,245,245);border-bottom-color:rgb(192,192,192);border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);"
          col="5"  row="14" colspan="4">备注</td>
        <!-- <td class="fh bw pl2 b0" style="display:none;" col="6"  row="14"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="7"  row="14"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="8"  row="14"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="9"  row="14"></td> -->
      </tr>
      <tr style="height:32px;" v-for="(pmmx,index) in project.pmmxs"  :key="index">
        <td class="fh bw pl2 b0" style="display:none;" col="0"
          row="15"  ></td>
        <td class="fh tac bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);border-bottom-color:rgb(192,192,192);"
          col="1" cv="1"  row="15" >{{index+1}}</td>
        <td class="fh tal bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);border-bottom-color:rgb(192,192,192);"
          col="2"  row="15"  > {{pmmx.pmmxname}}</td>
        <td class="fh tal bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);border-bottom-color:rgb(192,192,192);"
          col="3"  row="15" >{{pmmx.unitname}}</td>
        <td class="fh tar bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);border-bottom-color:rgb(192,192,192);"
          col="4" crow="15"  >{{pmmx.pmmxqty | qfwVal}}</td>
        <td class="fh tal bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);border-bottom-color:rgb(192,192,192);"
          col="5" row="15"  colspan="4">{{pmmx.pmmxremark}}</td>
        <!-- <td class="fh bw pl2 b0" style="display:none;" col="6" row="15"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="7"  row="15"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="8"  row="15"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="9"  row="15"></td> -->
      </tr>
      <tr style="height:31px;" tridx="16" >
        <td class="fh bw pl2 b0" style="display:none;" col="0"  row="16"></td>
        <td class="fh bw fwb f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);border-bottom-color:rgb(192,192,192);"
          col="1" colspan="8"  row="16" >注：详细需求请参考网站内容</td>
        <td class="fh bw pl2 b0" style="display:none;" col="9"  row="16"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="10"  row="16"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="11"  row="16"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="12"  row="16"></td>
      </tr>
      <tr style="height:336px;">
        <td class="fh bw pl2 b0" style="display:none;" col="0"  row="17"></td>
        <td class="fh bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="background-color:rgb(245,245,245);border-bottom-color:rgb(192,192,192);border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);"
          rowspan="1" col="1" row="17"  >项目需求</td>
        <td class="fh tal vat bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss presentable" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);border-bottom-color:rgb(192,192,192);"
          rowspan="1" col="2"
          colspan="7"  row="17" ><div v-html="project.prscontents"></div>
        </td>
        <td class="fh bw pl2 b0" style="display:none;" col="9" row="17"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="10" row="17"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="11" row="17"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="12" row="17"></td>
      </tr>
      <tr style="height:30px;" >
        <td class="fh bw pl2 b0" style="display:none;" col="0"  row="22"></td>
        <td class="fh bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="background-color:rgb(245,245,245);border-bottom-color:rgb(192,192,192);border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);"
          col="1"  row="22"  >公告附件</td>
        <td class="celink fh tal bw f10-0 tdu pl2 brw1 brss bbw1 bbss blw1 blss btw1 btss" style="color:rgb(0,0,255);border-bottom-color:rgb(192,192,192);border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);"
          col="2" colspan="7"  row="22" ><span
            class="linkspan" style="cursor:pointer;" >
           <!--<el-link v-for="(append,index) in appendList" type="primary" @click="downFile (append.appendurl)"  :key="index" target="_blank">{{append.appendfilename}}</el-link>-->
          <div v-if="appendList && appendList.length" class="filelist">
                <div v-for="(item,index) in appendList" :key="index" class="fileitem">
                  <div class="name" @click="downFile(item.appendurl)"><a :src="uploadAddr + item.appendurl">{{item.appendfilename}}</a>
                  </div>
                  <div class="btn" v-if="+project.projectstatus === 10" @click="delappend(item)"><span>删除</span></div>
                </div>
              </div>
        </span>
        </td>
        <td class="fh bw pl2 b0" style="display:none;" col="9"   row="22" ></td>
        <td class="fh bw pl2 b0" style="display:none;" col="10"
           row="22" >ea14ddbb-a274-47a4-bfcb-5768060010d7</td>
        <td class="fh bw pl2 b0" style="display:none;" col="11"  row="22"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="12" row="22"></td>
      </tr>
      <tr style="height:30px;">
        <td class="fh bw pl2 b0" style="display:none;" col="0"  row="25"></td>
        <td v-if = "project.projecttype ==='2'" class="fh tar bw f10-0 pl2 brw1 brss bb0 blw1 blss btw1 btss" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);" col="1"  colspan="8"  row="25"  idx="0">采购联系人:{{project.pusername}}</td>
        <td v-else  class="fh tar bw f10-0 pl2 brw1 brss bb0 blw1 blss btw1 btss" style="border-left-color:rgb(192,192,192);border-top-color:rgb(192,192,192);border-right-color:rgb(192,192,192);" col="1"  colspan="8"  row="25"  idx="0">采购人联系人:{{project.ausername}}</td>
        <td class="fh bw pl2 b0" style="display:none;" col="9"  row="25"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="10"  row="25"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="11"  row="25"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="12" ></td>
      </tr>
      <tr style="height:30px">
        <td class="fh bw pl2 b0" style="display:none;" col="0"  row="24"></td>
        <td class="fh tar  bw f10-0 pl2 brw1 brss bbw1 bbss blw1 blss bt0" style="border-left-color:rgb(192,192,192);border-right-color:rgb(192,192,192);border-bottom-color:rgb(192,192,192);"
          col="1"  colspan="8"  row="24">{{project.projecttime | newDate}}</td>
        <td class="fh bw pl2 b0" style="display:none;" col="9"  row="24"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="10"  row="24"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="11"  row="24"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="12"  row="24"></td>
      </tr>
      <tr style="height:19px;">
        <td class="fh bw pl2 b0" style="display:none;" col="0"  row="25"></td>
        <td class="fh bw pl2 b0" col="1" colspan="8"  row="25" ></td>
        <td class="fh bw pl2 b0" style="display:none;" col="9"  row="25"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="10"  row="25"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="11"  row="25"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="12"  row="25"></td>
      </tr>
      <tr style="height:28px;">
        <td class="fh bw pl2 b0" style="display:none;" col="0"  row="26" ></td>
        <td class="fh bw fwb f11-0 pl2 b0" col="1"  colspan="6"  row="26"
         >其他相关公告</td>
        <td class="fh tar bw pl2 b0" col="7"  colspan="2" row="26" >公告日期</td>
        <td class="fh bw pl2 b0" style="display:none;" col="9"  row="26"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="10"  row="26"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="11" row="26"></td>
        <td class="fh bw pl2 b0" style="display:none;" col="12"  row="26"></td>
      </tr>
      <tr style="height:26px;" v-for="(item,index) in project.noticeList" :key="index">
        <td class="fh bw pl2 b0" style="display:none;" col="0"  row="27"></td>
        <td class="celink fh bw f10-0 pl2 br0 bbw1 bbss bl0 btw1 btss" style="border-bottom-color:rgb(192,192,192);border-top-color:rgb(192,192,192);color:#3598db;"
          col="1" colspan="6" row="27"  @click="tiaozhuan(item)" ><span class="linkspan" style="cursor:pointer;">{{item.pjnoticetitle ? '['+item.pjnoticetitle+']' :'无相关公告'}}</span></td>
        <td class="fh tar bw f10-0 pl2 br0 bbw1 bbss bl0 btw1 btss" style="border-bottom-color:rgb(192,192,192);border-top-color:rgb(192,192,192);"
          col="7"  colspan="2"  row="27" >{{item.pjnoticetime | newDate}}</td>
        <td class="fh bw f10-0 pl2 br0 bbw1 bbss bl0 btw1 btss" style="border-bottom-color:rgb(192,192,192);display:none;border-top-color:rgb(192,192,192);"
          col="9" row="27" ></td>
        <td class="fh nw f10-0 pl2 br0 bbw1 bbss bl0 btw1 btss" style="border-bottom-color:rgb(192,192,192);display:none;border-top-color:rgb(192,192,192);"
          col="10"  row="27" ></td>
        <td class="fh bw pl2 b0" style="display:none;" col="11"  row="27" ></td>
        <td class="fh bw f10-0 pl2 br0 bbw1 bbss bl0 btw1 btss" style="border-bottom-color:rgb(192,192,192);display:none;border-top-color:rgb(192,192,192);"
          col="12"   row="27" ></td>
      </tr>
    <el-dialog :close-on-click-modal="false" @close="dialogClose" :visible.sync="dialogVisible" width="80%">
      <div  v-if="dialogType===1">
        <!--结果公告-->
        <project-result-notice :projectid="projectid"></project-result-notice>
      </div>
      <div v-if="dialogType===2">
        <project-other-notice :noticeid="noticeid"></project-other-notice>
      </div>
    </el-dialog>
    </tbody>
  </table>
    </div>
  </Container>
</template>
<script>
  import {getLodop} from '@/assets/js/LodopFuncs'
  import utils from '../../assets/js/utils'
  import request from '@/utils/request'
  import common from '@/mixin/common'
  import config from '../../assets/config'
  import uploadBtn from '../common/uploadBtn'
  import ProjectResultNotice from './projectResultNotice'
  import ProjectOtherNotice from './ProjectOtherNotice'
  import _ from 'lodash'
  let LODOP
  export default {
    name: 'projectNotice',
    mixins: [common],
    props: {
      cproject: Object,
      ctype: Number
    },
    components: {uploadBtn,ProjectResultNotice,ProjectOtherNotice},
    data () {
      return {
        projectid: this.$route.params.projectid,
        type: this.$route.params.type,
        btnLoading: false,
        project: {},
        appendList: [],
        dialogVisible:false,
        dialogType: '',
        alertmsg: ''
      }
    },
    created () {
    },
    activated() {
      this.init()
      this.getProject()
      this.getAppends ()
    },

    filters:{
      newDate(value){
        return utils.formatterDate(value, 'yyyy-MM-dd HH:mm:ss')
      },
      qfwVal(value) {
        return utils.comdify(value)
      }
    },
    computed: {
      uploadAddr () {
        return this.$store.getters.uploadAddr
      }
    },
    mounted () {
      this.init()
      this.getProject()
      this.getAppends ()
      // this.tiaozhuan()
    },
    methods: {
      async init() {
        // this.projectid = this.cproject.projectid || this.$route.params.projectid
        if(this.cproject){
          this.projectid = this.cproject.projectid
        }
        else
          this.projectid = this.$route.params.projectid
        this.type = this.ctype || this.$route.params.type
        this.btnLoading = false
        this.project = {}
        this.appendList = []
      },
      async delappend(file) {
        this.$confirm(`确定删除 ${ file.appendfilename }？`, '提示', {
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/ywgl/append/delAppend',
            method: "post",
            data: {appendid: file.appendid}
          })
          if (data.issuccess===1) {
            await this.getAppends ()
            this.$message.success('竞价文件删除成功')
          } else {
            this.$message.error('竞价文件删除失败')
          }
          this.getAppends()
        }).catch(() => {
        })
      },
      async setfile (path, filename) {
        let append = {
          appendid: 0,
          appendfromid: this.project.projectid,
          appendfromtype: '5',
          appendtype: '100',
          appendseq: this.appendList.length ? this.appendList.length +1 : 1,
          appendfilecode: '',
          appendfilename: filename,
          appendurl: path.replace(this.uploadAddr,'')
        }
        let data = await request({
           url: '/ywgl/append/addOrEdit',
           method: "post",
           data: append
         })
         if (data.issuccess===1) {
           await this.getAppends ()
           this.$message.success('公告附件上传成功')
         } else {
           this.$message.error('公告附件上传失败')
         }
        // console.log(this.appendList, 222222222222222)
      },
      dialogClose () {
        this.dialogVisible = false
        this.dialogType = 0
      },
      async getProject () {
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getProjectById',
          params: { projectid: this.projectid }
        })
        this.project = res[0]
      },
      async getAppends () {
        this.appendList = await request({
          method: 'get',
          url: '/ywgl/append/getAppendListByFromId',
          params: {appendfromid: this.projectid, appendfromtype: 5}
        })
      },
      // async tiaozhuan (item) {
      //   item.wmenu = item
      //   item.porjectid = this.project.projectid
      //   this.$router.push({name: 'pjnoticeForm', params: {form: item, type: 2}})
      // },
      
      async tiaozhuan (item) {
        console.log(item)
        if (item.wmenudatawhere) {
          this.noticeid = item.pjnoticeid
          this.dialogVisible = true
          this.dialogType = 2
        } else {
          this.dialogVisible = true
          this.dialogType = 1
        }
        // item.wmenu = item
        // item.porjectid = this.project.projectid
        // this.$router.push({name: 'noticeForm', params: {form: item, type: 2}})
      },
      close() {
        let returnForm = 'projectIndex'
        if (this.project.projecttype === '2') {
          returnForm = 'projectZjIndex'
        }
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: returnForm})
      },
      async fbgg() {
        this.btnLoading = true
        if (this.project.projectstatus!=='10') {
          this.$message.warning('项目公告已发布，不能重复发布！')
          return
        }
        //自动作业
        // await request({
        //   url: '/index/updatebm',
        //   method: "post",
        //   data: {
        //           projectid: this.project.projectid,
        //           prsbjbegtime:this.project.prsbjbegtime
        //     }
        // })
        await this.checkScore()
        if (this.alertmsg) {
          this.$message.warning(this.alertmsg)
          this.btnLoading = false
          setTimeout(() => {
            this.$router.push({name: 'projectReviewRuleIndex', params: {projectid: this.project.projectid, activeName: 'pfxm', type: 1}})
          }, 900)
          return
        }
        let data = await request({
          url: '/xmgl/project/projectFbgg',
          method: "post",
          data: {projectid: this.project.projectid,userid: this.$store.getters.loginUser.userid,status: '20'}
        })
        if (data.issuccess===1) {
          this.close()
          this.$message.success('项目公告发布成功！')
        } else {
          this.$message.error('项目公告发布失败！')
        }
        this.btnLoading = false
      },
      async checkScore () {
        this.alertmsg = ''
        let res = await request({
          method: 'get',
          url: '/xmgl/pg/getPgList',
          params: {projectid: this.project.projectid}
        })
        if (res.list.length) {
          let ratioTotal = res.list.map(t => Number(t.pgratio)).reduce((a, b) => a + b)
          if (ratioTotal !== 100) {
            if (+this.project.projectpgstotalrule === 1) {
              this.alertmsg = '当前项目总分计算方式为"百分比"，评分项目的权重合计必须等于100，请重新设置！'
            } else {
              this.alertmsg = '当前项目总分计算方式为"绝对值"，评分项目的分值合计必须等于100分，请重新设置!'
            }
          }

          let scoreTotal = res.list.map(t => Number(t.pgscore)).reduce((a, b) => a + b)
          if (+this.project.projectpgstotalrule === 2) {
            if (scoreTotal !== 100) {
              this.alertmsg = `当前项目总分计算方式为"绝对值"，评分项目的分值合计必须等于100分，请重新设置!`
            }
          } else if (+this.project.projectpgstotalrule === 1) {
            if (scoreTotal !== 300) {
              this.alertmsg = `当前项目总分计算方式为"百分比"，评分项目的各项分值合计必须等于100分，请重新设置!`
            }
          }
        }
      },
      async lodopPrint () {
        LODOP = await getLodop()
        var style = document.createElement('link')
        style.href = 'http://120.78.91.121:9600/upload/20200806/1596702260371.css'
        style.rel = 'stylesheet'
        style.type = 'text/css'
        document.getElementById("px").appendChild(style)
        if (LODOP) {
          LODOP.SET_PRINT_STYLE("FontSize",10);
          LODOP.ADD_PRINT_HTM(	10, 0, "90%", "80%",document.getElementById("px").innerHTML);
          LODOP.PREVIEW();
        }
      },
    }
  }
</script>
<style lang="scss" scoped>
  @import "../../styles/filelist";
</style>
<style scoped>
  .groupbtn {
    display: flex;
    align-items: center;
  }
.status {
  color: red;
  padding-left: 10px;
}
.x-table {
	overflow: hidden;
	table-layout: fixed;
	border-collapse: collapse;
	*word-break: break-all;
	*overflow: visible
}

.fx {
	overflow: hidden
}

.frozen-row {
	border-bottom: 0 solid transparent;
	overflow: hidden
}

.frozen-column {
	border-right: 0 solid transparent;
	overflow: hidden
}

.fx table {
	border-collapse: collapse;
	table-layout: fixed;
	border-spacing: 0
}

.wrap {
	overflow: auto
}

.nw {
	white-space: nowrap;
	*white-space: pre
}

.bw {
	word-wrap: break-word
}

.fh {
	overflow: hidden;
	padding: 0;
	vertical-align: middle;
	text-align: left;
	font-size: 9pt;
	font-family: SimSun
}

.fh-nopadding {
	overflow: hidden;
	padding: 0;
	vertical-align: middle;
	text-align: left;
	font-size: 12px;
	font-family: SimSun
}

.f8-0 {
	font-size: 8pt
}

.f9-0 {
	font-size: 9pt
}

.f10-0 {
	font-size: 10pt
}

.f11-0 {
	font-size: 11pt
}

.f12-0 {
	font-size: 12pt
}

.f13-0 {
	font-size: 13pt
}

.f14-0 {
	font-size: 14pt
}

.f15-0 {
	font-size: 15pt
}

.f16-0 {
	font-size: 16pt
}

.f17-0 {
	font-size: 17pt
}

.f18-0 {
	font-size: 18pt
}

.f19-0 {
	font-size: 19pt
}

.f20-0 {
	font-size: 20pt
}

.f21-0 {
	font-size: 21pt
}

.f22-0 {
	font-size: 22pt
}

.f23-0 {
	font-size: 23pt
}

.f24-0 {
	font-size: 24pt
}

.f25-0 {
	font-size: 25pt
}

.f26-0 {
	font-size: 26pt
}

.f8-5 {
	font-size: 8.5pt
}

.f9-5 {
	font-size: 9.5pt
}

.f10-5 {
	font-size: 10.5pt
}

.f11-5 {
	font-size: 11.5pt
}

.f12-5 {
	font-size: 12.5pt
}

.f13-5 {
	font-size: 13.5pt
}

.f14-5 {
	font-size: 14.5pt
}

.f15-5 {
	font-size: 15.5pt
}

.f16-5 {
	font-size: 16.5pt
}

.f17-5 {
	font-size: 17.5pt
}

.f18-5 {
	font-size: 18.5pt
}

.f19-5 {
	font-size: 19.5pt
}

.f20-5 {
	font-size: 20.5pt
}

.f21-5 {
	font-size: 21.5pt
}

.f22-5 {
	font-size: 22.5pt
}

.f23-5 {
	font-size: 23.5pt
}

.f24-5 {
	font-size: 24.5pt
}

.f25-5 {
	font-size: 25.5pt
}

.f26-5 {
	font-size: 26.5pt
}

.fnab {
	font-family: Arial Black
}

.fnbs {
	font-family: Basic Sans SF
}

.fnba {
	font-family: Book Antiqua
}

.fnci {
	font-family: Calibri
}

.fncs {
	font-family: Comic Sans MS
}

.fncn {
	font-family: Courier New
}

.fnes {
	font-family: Elementary SF
}

.fngd {
	font-family: Garamond
}

.fnga {
	font-family: Georgia
}

.fnlg {
	font-family: Letter Gothic
}

.fnlc {
	font-family: Lucida Console
}

.fnmd {
	font-family: Marigold
}

.fnms {
	font-family: MS Sans Serif
}

.fnmg {
	font-family: MS Gothic
}

.fnmpg {
	font-family: MS PGothic
}

.fnmm {
	font-family: MS Mincho
}

.fnmpm {
	font-family: MS P Mincho
}

.fnml {
	font-family: MingLiU
}

.fnsh {
	font-family: SimHei
}

.fnsm {
	font-family: System
}

.fnta {
	font-family: Tahoma
}

.fntn {
	font-family: Times New Roman
}

.fntms {
	font-family: Trebuchet MS
}

.fnva {
	font-family: Verdana
}

.fnss {
	font-family: SimSun
}

.fnar {
	font-family: Arial
}

.fnyh {
	font-family: Microsoft YaHei
}

.fnkt {
	font-family: KaiTi
}

.fwb {
	font-weight: bold
}

.fsi {
	font-style: italic
}

.tdu {
	text-decoration: underline
}

.tdst {
	text-decoration: line-through
}

.tdstu {
	text-decoration: line-through underline
}

.fvsc {
	font-variant: small-caps
}

.super {
	vertical-align: 100%!important
}

.super sup {
	vertical-align: 100%
}

.suber {
	vertical-align: ""
}

.suber sub {
	vertical-align: -120%;
	*vertical-align: sub
}

.shadow {
	text-shadow: 1px 1px 2px black
}

.tac {
	text-align: center
}

.tar {
	text-align: right
}

.tal {
  text-align: left;
  padding-left: 10px !important;
}

.vab {
	vertical-align: bottom
}

.vat {
	vertical-align: top
}

.pl0 {
	padding-left: 0
}

.pr0 {
	padding-right: 0
}

.pl1 {
	padding-left: 1px
}

.pr1 {
	padding-right: 1px
}

.pl2 {
	padding-left: 2px;
	*padding-left: 0
}

.pr2 {
	padding-right: 2px;
	*padding-right: 0
}

.b0 {
	border: 0
}

.b1 {
	border: 1px solid #000
}

.bt0 {
	border-top: 0
}

.bb0 {
	border-bottom: 0
}

.bl0 {
	border-left: 0
}

.br0 {
	border-right: 0
}

.bt1 {
	border-top: 1px solid #000
}

.bb1 {
	border-bottom: 1px solid #000
}

.bl1 {
	border-left: 1px solid #000
}

.br1 {
	border-right: 1px solid #000
}

.btcb {
	border-top-color: #000
}

.bbcb {
	border-bottom-color: #000
}

.blcb {
	border-left-color: #000
}

.brcb {
	border-right-color: #000
}

.btw1 {
	border-top-width: 1px
}

.bbw1 {
	border-bottom-width: 1px
}

.blw1 {
	border-left-width: 1px
}

.brw1 {
	border-right-width: 1px
}

.btw2 {
	border-top-width: 2px
}

.bbw2 {
	border-bottom-width: 2px
}

.blw2 {
	border-left-width: 2px
}

.brw2 {
	border-right-width: 2px
}

.btw3 {
	border-top-width: 3px
}

.bbw3 {
	border-bottom-width: 3px
}

.blw3 {
	border-left-width: 3px
}

.brw3 {
	border-right-width: 3px
}

.btss {
	border-top-style: solid
}

.bbss {
	border-bottom-style: solid
}

.blss {
	border-left-style: solid
}

.brss {
	border-right-style: solid
}

.btsd {
	border-top-style: double
}

.bbsd {
	border-bottom-style: double
}

.blsd {
	border-left-style: double
}

.brsd {
	border-right-style: double
}

.btsda {
	border-top-style: dashed
}

.bbsda {
	border-bottom-style: dashed
}

.blsda {
	border-left-style: dashed
}

.brsda {
	border-right-style: dashed
}

.btsdo {
	border-top-style: dotted
}

.bbsdo {
	border-bottom-style: dotted
}

.blsdo {
	border-left-style: dotted
}

.brsdo {
	border-right-style: dotted
}

.notice-content{
 width: 100vw;
 height: 100vh;
 display: flex;
 flex-direction: column;
 text-align: center
}
.notice-content .title {

}
</style>
